import { FC, memo } from 'react';
import classNames from 'classnames';
import Button from 'antd/lib/button/button';
import Divider from 'antd/lib/divider';

import { IStepComponentProps } from 'components/ImportCsv/constants';
import { IModalProps } from 'components/Modal/constants';

const Footer: FC<IStepComponentProps & IModalProps> = ({ step, setStep, onModalClose }) => {
  const handleBack = () => setStep(step - 1);

  const handleNext = () => step === 3 ? onModalClose() : setStep(step + 1);

  return (
    <>
      <Divider />
      <div className="d-f ai-c jc-sb">
        <Button
          size="large"
          type="link"
          className={classNames('p-0 dark-link', { hidden: !step })}
          onClick={handleBack}
        >
          Back
        </Button>
        <Button size="large" type="primary" onClick={handleNext}>{step === 3 ? 'Done' : 'Next'}</Button>
      </div>
    </>
  );
};

export default memo(Footer);
